import { VisualState, useKBar } from "kbar";
import { useCallback } from "react";
import { t } from "ttag";

import { ToolbarButton } from "metabase/common/components/ToolbarButton";

export const Search = () => {
  const kbar = useKBar();
  const { setVisualState } = kbar.query;

  const handleClick = useCallback(() => {
    setVisualState(VisualState.showing);
  }, [setVisualState]);

  return (
    <ToolbarButton
      tooltipLabel={t`Search`}
      icon={"search"}
      onClick={handleClick}
      aria-label={"Search"}
    />
  );
};
